var map = {
	"./Image assign 3.png": 30071,
	"./batch_img.jpg": 13628,
	"./batch_img_eg.png": 12273,
	"./blog_profile_face.png": 49142,
	"./blog_profile_link.png": 95273,
	"./blog_profile_twit.png": 11969,
	"./certificate_img.png": 97917,
	"./csvfile.png": 27310,
	"./csvicon.png": 13863,
	"./cvsicon.png": 84553,
	"./docsicon.png": 744,
	"./edit-pencil-img.png": 29420,
	"./email_chat_user.png": 3285,
	"./excelicon.png": 41246,
	"./fileicon.png": 94615,
	"./folder-open.png": 21989,
	"./forder-img.png": 84862,
	"./giffile.png": 77728,
	"./gsheeticon.png": 8085,
	"./icons8-excel-32.png": 32490,
	"./icons8-facebook-32.png": 57033,
	"./icons8-instagram-32.png": 24961,
	"./icons8-linkedin-2-32.png": 48688,
	"./icons8-linkedin-32.png": 82691,
	"./icons8-x-32.png": 73541,
	"./img-avatar.png": 84659,
	"./ipynbfile.png": 52022,
	"./jpegfile.png": 94474,
	"./jsonfile.png": 35818,
	"./loginimg.png": 99970,
	"./mail_swap.png": 84593,
	"./module-pdf-img.png": 82593,
	"./module-video-img.png": 74938,
	"./module_placeholder.png": 85648,
	"./not_email.png": 32918,
	"./odticon.png": 41320,
	"./oeson-blue.png": 35727,
	"./oeson-learn-logo.png": 47017,
	"./pdficon.png": 81769,
	"./pngfile.png": 17679,
	"./pyfile.png": 51037,
	"./refer-arrow 1.svg": 50859,
	"./resource_color.png": 6714,
	"./resource_fol.png": 20364,
	"./resource_name.png": 25478,
	"./resource_refer.png": 84613,
	"./resource_trash.png": 21361,
	"./resourcenot.png": 26959,
	"./rtficon.png": 98803,
	"./student-report-img.png": 52476,
	"./txticon.png": 46659,
	"./undraw_studying_n5uj.png": 63898,
	"./video-placeholder.png": 74237,
	"./work-img.png": 24575,
	"./xlsfile (2).png": 73294,
	"./xlsfile.png": 91793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15687;